import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-cloudsignersuccess',
  templateUrl: './cloudsignersuccess.component.html',
  styleUrls: []
})
export class CloudsignersuccessComponent implements OnInit {
  Idproceso = '';
  constructor(private route: ActivatedRoute) {
    this.route.params.subscribe(params => {
      if (params.id !== '' || params.id !== undefined) {
        this.Idproceso = `${params.id}`;
      }
    });
  }

  ngOnInit(): void {
    // This is intentional
  }

}
